import{jsx as _jsx}from"react/jsx-runtime";export const CodeUserland=({children})=>{return _jsx("span",{className:"bg-gray-300 p-2xs",children:children})};